import React from 'react';
import User from './User';

export const UserContext = React.createContext(new User());

